@if (permissionService.canLogistAddDevices$ | async) {
  <button
    tuiIconButton
    type="button"
    size="s"
    (click)="removeRequestDevice$.next()"
    appearance="transparent"
  >
    <tui-icon
      [style.border-width.rem]="0.25"
      icon="@tui.trash-2"
      class="text-2xl! text-(--x-color-danger)"
    ></tui-icon>
  </button>
}
